import utils from "./index.js";
import axios from "axios";

/** 默认版本号  */
let headers = {
  "Content-Type": "application/json; charset=utf-8",
  xfrom: "7",
};

let service = axios.create({
  timeout: 5000,
  headers: headers,
});

/**
 * get 请求
 *
 * @param {any} url - 接口地址
 * @param {any} options - 请求参数体
 * @returns
 */
function get(url, options) {
  return new Promise((resolve, reject) => {
    service({
      method: "get",
      url,
      params: options,
    })
      .then((res) => {
        console.log("get========", res);

        resolve(res);
      })
      .catch((error) => {
        console.log(error, "get异常");
        reject(error);
      });
  });
}

function post(url, options) {
  return new Promise((resolve, reject) => {
    service({
      method: "post",
      url,
      data: options,
    })
      .then((res) => {
        console.log("post----------", res);
        resolve(res);
      })
      .catch((error) => {
        console.log(error, "post异常");
        reject(error);
      });
  });
}

/**
 * post请求
 * 小程序post请求header中的content-type必须设置为'application/x-www-form-urlencoded'
 * @param {any} url
 * @param {any} options
 * @returns
 */

export default {
  get,
  post,
};
